import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { withFirebase } from '../Firebase';
import './ChallengeCreatorPage.css'
import picture from '../assets/icon_picture.svg'
import attachment from '../assets/icon_attachments.svg'
import Modal from "react-responsive-modal";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import IdeaCardB from "./IdeaCard"
import IconPlus from "../../assets/cards/icon_plus.svg"
import backgroundBase from "../assets/bg_header.svg"
import { relative } from 'path';
import CreatePollModalContent from '../Home/CreatePollModalContent'
import SinglePoll from "../Home/SinglePoll";
import IdeaModal from "./IdeaModal";
import uuid from 'uuid/v1';
import close_icon from "../assets/left-arrow.svg";
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import confirmationDesktop from '../../assets/confirmation_v2.svg';
import Tooltip from '@material-ui/core/Tooltip';
import close from "../../components/assets/close.png";
import ScopeModal from './ScopeModal';
import * as firebase from 'firebase';

class ChallengeCreatorPage extends Component {
  onClose = () => {
    return this.props.history.goBack()
  }

  render() {
    let width = window.innerWidth;
    if (width > 768) {
      return (
        <div className="custom-background">
          <img className="close_icon_pos" onClick={this.onClose} src={close_icon} alt="close" />
          <ChallengeCreatorForm />
        </div>)
    } else {
      return (
        <div className="custom-background">
          <img className="close_icon_pos" onClick={this.onClose} src={close_icon} alt="close" />
          <ChallengeCreatorForm />
        </div>
      )
    }
  }
}

const INITIAL_STATE = {
  company: '',
  status: '',
  creator: '',
  assigner: '',
  title: '',
  file: '',
  scopeTeam: false,
  scopePeer: false,
  resolutionTime: 0,
  importance: '',
  tags: [],
  description: '',
  image: null,
  images_url: '',
  ideaOpen: false,
  scopeOpen: false,
  tags_idea: [],
  ideas: [],
  polls: [],
  idea: false,
  managers: [],
  current_uid: '',
  current_user: [],
  createPollOpen: false,
  confirmationOpen: false,
  creationLoading: false,
  imageLoading: false,
  wrongTag: false,
  creationIdeaLoading: false,
};

class ChallengeCreatorBaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, attachmentList: [], backgroundList: [] };
  }

  componentDidMount() {
    document.body.style.background = "#F8F9FB";
    let uid;
    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid, polls: [], ideas: [] })
      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then(doc => {
          this.setState({
            current_user: doc.data()
          });
        });

      this.props.firebase.db.collection("background")
        .doc("listBackground")
        .get()
        .then(doc => {
          this.setState({
            backgroundList: doc.data().list
          });
        });
    }

  }

  onSubmitChallengeInformations = async event => {
    this.setState({ creationLoading: true });
    event.preventDefault();

    let id_capsule;
    let likeList = [];

    const { title, description, tags, image, ideas, polls, current_user, current_uid, attachmentList } = this.state;
    const timestamp = Date.now();
    let managers = []

    if (this.state.scopePeer) {
      managers.push(current_user.manager)
    }
    if (this.state.scopeTeam) {
      managers.push(current_uid)
    }

    const newCapsule = { title: title, description: description, tags: tags, managers: managers, creator: current_uid, nbLikes: 0, likeList: likeList, creationDate: timestamp, sortingScore: 10, nbIdeas: 0, nbLikeIdeas: 0 }
    const newHistoric = { date: timestamp, firstname: current_user.firstname, lastname: current_user.lastname, picture: current_user.image_url_profile, status: "create", }
    let url;

    if (image) {
      let imageUuid = uuid();
      await this.props.firebase.storage.ref(`images/${imageUuid}`).put(image)
      url = await this.props.firebase.storage.ref('images').child(imageUuid).getDownloadURL()
      newCapsule.image_url_capsule = url
    } else {
      let random = Math.random() * (this.state.backgroundList.length - 0) + 0;
      newCapsule.image_url_capsule = this.state.backgroundList[Math.floor(random)];
    }

    if (attachmentList) {
      let attachmentsURLs = []

      for (const attachment of attachmentList) {
        let attachmentUuid = uuid();
        await this.props.firebase.storage.ref(`PJ/${attachmentUuid}`).put(attachment)
        let url = await this.props.firebase.storage.ref('PJ').child(attachmentUuid).getDownloadURL()
        attachmentsURLs.push({ fileName: attachment.name, url });
      }

      newCapsule.attachments = attachmentsURLs
    }
    newCapsule.nbIdeas = ideas.length

    let docRef = await this.props.firebase.db.collection('capsules').add(newCapsule)
    id_capsule = docRef.id;

    await this.props.firebase.db.collection('capsules').doc(id_capsule).collection('historic').add(newHistoric)

    for (const idea of ideas) {
      await this.props.firebase.db.collection('capsules').doc(id_capsule).collection('ideas').add(idea)
    }

    for (const poll of polls) {
      await this.props.firebase.db.collection('capsules').doc(id_capsule).collection('polls').add(poll)
    }
    this.setState({ creationLoading: false });
    this.openConfirmation();
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  topChallengeCreator = () => {
    const {
      title,
    } = this.state;

    return (
      <div className="cointainer">
        <div className="row text-center no-margin">
          <div className="col delete">
          </div>
          <div className="col justify-content-center">
            <div className="mt-5 mb-5">
              <h1 className="title-challenge">Votre capsule d'amélioration</h1>
              <input className="pl-3 challenge-input"
                name="title"
                type="text"
                maxlength="70"
                onChange={this.onChange}
                placeholder="Le titre de la capsule"
                value={title} required
              />
            </div>
          </div>
          <div className="col delete">
          </div>
        </div>
      </div>
    )
  }

  handleChange = e => {
    e.persist()
    if (e.target.files[0]) {
      this.addAttachement(e);
      const current_image = e.target.files[0];
      this.setState({ image_url: URL.createObjectURL(current_image), image: current_image });
    }
  }

  addAttachement = e => {
    e.persist()
    let { attachmentList } = this.state

    let newAttachements = e.target.files

    for (let i = 0; i < newAttachements.length; ++i) {
      attachmentList.push(newAttachements[i])
    }

    this.setState({ attachmentList })
  }

  handleChangeTags = (tags) => {
    this.setState({ tags: tags, wrongTag: false });
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
    }
  }

  deleteAttachement = (index) => {
    const { attachmentList } = this.state

    let attachList = attachmentList

    attachList.splice(index, 1);
    this.setState({ attachmentList: attachList });
  }

  inputChallenge = () => {
    const {
      description, tags, attachmentList
    } = this.state
    let attachList = attachmentList || [{ name: "" }];

    return (
      <div className="cointainer">
        <div className="row text-center no-margin">
          <div className="col"></div>
          <div className="col">
            <div className="d-flex justify-content-center">
              <label htmlFor="import-picture" className="import">
                <Tooltip title="Photo de couverture" aria-label="cover">
                  <img alt="icon" className="position-icon cursor-pointer" src={picture} />
                </Tooltip>
              </label>
              <input onChange={this.handleChange} hidden={true} id="import-picture" className="import" type="file" />
              <label htmlFor="import-attachement">
                <Tooltip title="Pièces jointes" aria-label="attachment">
                  <img alt="icon" className="position-icon cursor-pointer" type="file" src={attachment} />
                </Tooltip>
              </label>
              <input onChange={this.addAttachement} hidden={true} id="import-attachement" className="import" type="file" multiple />
            </div>
            <div hidden={!attachmentList}>
              {attachList.map((attachment, index) =>
                <div className="d-flex">
                  <img onClick={() => this.deleteAttachement(index)} src={close} className="close cursor-pointer" alt="attachment"></img>
                  <h1 className="fichier">{attachment.name}</h1>
                </div>)}
            </div>
            <div className="background-curve">
              <div className="mt-3 text-center">
                <h1 className="mb-3 title-theme">Thème(s) associé(s)</h1>
                <TagsInput onValidationReject={this.rejectTag} validationRegex={/^[a-zA-Z0-9]{0,25}$/} maxTags={6} value={tags} onChange={this.handleChangeTags} />
              </div>
              <div hidden={!this.state.wrongTag}><h4 className="wrong-tag mt-2">Tag non valide</h4></div>
              <div className="mt-5 pb-3">
                <h1 className="mb-3 title-theme">Décrire le problème rencontré</h1>
                <textarea className="text-area pl-3"
                  rows="3"
                  onChange={this.onChange}
                  placeholder="Pourquoi est-ce important ?"
                  name="description"
                  value={description}
                  required
                ></textarea>
              </div>
            </div>
          </div>
          <div className="col"></div>
        </div>
      </div>
    )
  }

  rejectTag = () => {
    this.setState({ wrongTag: true })
  }

  addPolls = () => {
    const { polls, image_url, tags } = this.state
    return (
      <div className="text-center white-background-middle mt-3">
        <button className="button-challenge" type="button" onClick={() => this.openCreatePoll()}>
          <img alt="icon" className="img-btn" src={IconPlus} />
          Ajouter un sondage</button>
        <div>
          <div className="d-flex idea-list">
            {polls.map((poll, index) => <div key={poll.title}>
              <SinglePoll key={index}
                src={image_url || backgroundBase}
                topic={tags[0]}
                visited={true} />
            </div>)}
          </div>
        </div>
      </div>
    )
  }

  renderIdeas = () => {
    const { ideas } = this.state

    return (
      <div className="white-background-bottom mt-3">
        <div className="text-center">
          <button className="button-challenge" type="button" onClick={() => this.openIdea()}>
            <img alt="icon" className="img-btn-two" src={IconPlus} />Ajouter une Idée</button>
        </div>
        <div>
          <div className="d-flex idea-list">
            {ideas.map((idea, index) => <div className="" key={index}>
              <IdeaCardB
                index={index + 1}
                idea={idea}
                canAddComment={false}
                canAddLike={false}
              />
            </div>)}
          </div>
        </div>
      </div>
    )
  }


  addToPolls = (poll) => {
    let { polls } = this.state;
    polls.push(poll)
    this.setState({
      polls
    })
  }

  openCreatePoll = () => {
    this.setState({
      createPollOpen: true
    })
  }

  closeCreatePoll = () => {
    this.setState({
      createPollOpen: false
    })
  }

  adaptStyles = () => {

    let width = window.innerWidth;
    if (width > 768) {
      return styles_desktop;
    } else {
      return styles_mobile;
    }
  }

  openIdea = () => {
    this.setState({
      ideaOpen: true
    })
  }

  closeIdea = () => {
    this.setState({
      ideaOpen: false,
    })
  }

  openScope = () => {
    this.setState({
      scopeOpen: true
    })
  }

  closeScope = () => {
    this.setState({
      scopeOpen: false,
    })
  }

  test = () => {
    this.setState({ idea: true });
    this.setState({
      ideaOpen: false,
    })
  }

  setDescriptionIdea = description => {
    this.setState({ description_idea: description });
  }

  setTagsIdea = tags => {
    this.setState({ tags_idea: tags });
  }

  setScope = (peer, team) => {
    this.setState({ scopeTeam: team, scopePeer: peer })
  }

  addToIdeas = async (idea) => {
    this.setState({ creationIdeaLoading: true })
    let { ideas } = this.state;
    let current_idea = idea;
    let attachmentListUrl;
    if (idea.attachments) {
      attachmentListUrl = [];
      for (const attachment of idea.attachments) {
        let attachmentUuid = uuid();
        await this.props.firebase.storage.ref(`PJ/${attachmentUuid}`).put(attachment)
        let url = await this.props.firebase.storage.ref('PJ').child(attachmentUuid).getDownloadURL()
        attachmentListUrl.push({ fileName: attachment.name, url });
      }
      current_idea.attachments = attachmentListUrl;
      current_idea.urlList = null;
    }
    ideas.push(current_idea)

    this.setState({
      ideas,
      creationIdeaLoading: false
    })
    this.closeIdea();
  }

  openConfirmation = () => {
    this.setState({
      confirmationOpen: true,
      imageLoading: true
    })
  }

  closeConfirmation = () => {
    this.setState({
      confirmationOpen: false
    })
    this.props.history.push(ROUTES.HOME)
  }

  onLoadImage = () => {
    this.setState({ imageLoading: false })
  }

  render() {
    const {
      image_url,
      creationLoading,
      imageLoading,
      creationIdeaLoading
    } = this.state;
    const { classes } = this.props


    var divStyle = {
      backgroundImage: 'url(' + image_url + ')',
      positon: relative,
    };

    var divStyleGrey = {
      backgroundImage: 'url(' + backgroundBase + ')'
    };

    let test

    if (image_url) {
      test = divStyle;
    } else {
      test = divStyleGrey;
    }


    return (
      <div>
        <form onSubmit={this.onSubmitChallengeInformations} method="POST">
          <div style={test} className="img-background">
            <div className="img-filter">
              {this.topChallengeCreator()}
            </div>
          </div>
          <div className="background-curve">
            {this.inputChallenge()}
          </div>
          {this.addPolls()}
          <Modal
            open={this.state.createPollOpen}
            onClose={this.closeCreatePoll}
            center
            showCloseIcon={true}
            styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
          >
            <CreatePollModalContent onClose={this.closeCreatePoll}
              onAddPolls={this.addToPolls}
            />
          </Modal>
          {this.renderIdeas()}

          <div className="d-flex justify-content-center position-relative">
            <button className="text-center mt-4 mb-5 create-btn" type="button" onClick={this.openScope} disabled={this.state.description.length === 0 || this.state.title.length === 0 || creationLoading}>Créer</button>
            {creationLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
          <Modal
            open={this.state.ideaOpen}
            onClose={this.closeIdea}
            center
            showCloseIcon={true}
            styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
          >
            <IdeaModal onClose={this.closeIdea}
              setDescription={this.setDescriptionIdea}
              setTags={this.setTagsIdea}
              onAddIdea={this.addToIdeas}
              onTest={this.test}
              creator={this.state.current_uid}
              loading={creationIdeaLoading} />
          </Modal>

          <Modal
            open={this.state.scopeOpen}
            onClose={this.closeScope}
            center
            showCloseIcon={true}
            styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
          >
            <ScopeModal
              onClose={this.closeScope}
              setScope={this.setScope}
              creationLoading={creationLoading}
            />
          </Modal>
          <Modal
            open={this.state.confirmationOpen}
            onClose={this.closeConfirmation}
            center
            showCloseIcon={true}
            classNames={{ 'closeButton': 'closeIconModal' }}
            styles={styles_confirmation}
            closeIconSvgPath={<path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" fill="#FFFFFF"></path>}
          >
            {imageLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            <img src={confirmationDesktop} className="h-100 w-100 p-0 object-fit-cover" onLoad={this.onLoadImage} alt="confirmation" />

          </Modal>
        </form>
      </div>
    );
  }
}

const styles_desktop = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "541px",
    maxWidth: "376px",
    top: "10%",
    padding: "0px",
  }
};

const styles_mobile = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    boxShadow: 'none',
    minHeight: "100%",
    width: "100%",
    padding: "0px",
  }
};

const styles_confirmation = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    width: (window.innerWidth > 768) ? '20vw' : '80vw',
    top: '20vh',
    padding: "0px",
    background: "rgba(0,0,0,0)",
  }
};

const styles_loader = theme => ({
  root: {
  },
  buttonProgress: {
    color: '#0070A2',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -12,
  },
});

ChallengeCreatorBaseForm.propTypes = {
  classes: PropTypes.object.isRequired,
};


const ChallengeCreatorForm = withRouter(withFirebase(withStyles(styles_loader)(ChallengeCreatorBaseForm)));

export { ChallengeCreatorBaseForm };
export default ChallengeCreatorPage;
